import { type FC, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SectionContext, type NavSectionId } from '@/components/Page/SectionContext';
import { rememberPlaySection } from '@/navigation/redirects';

export interface SectionLayoutProps {
  section: NavSectionId;
}

/**
 * SectionLayout - layout route for Hobby, Play and You pages. It tells `Page` which
 * sub-navigation to render, so pages never render SectionNav themselves.
 */
export const SectionLayout: FC<SectionLayoutProps> = ({ section }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (section === 'play') rememberPlaySection(pathname);
  }, [section, pathname]);
  return (
    <SectionContext.Provider value={section}>
      <Outlet />
    </SectionContext.Provider>
  );
};

/**
 * BareLayout - owns the `main` landmark for routes that do not use `Page`
 * (public pages, the live battle screen, print views).
 */
export const BareLayout: FC = () => (
  <main id="main-content" tabIndex={-1} className="flex-1 focus:outline-none">
    <Outlet />
  </main>
);
